'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _navigator = require('../utils/navigator');

var _navigator2 = _interopRequireDefault(_navigator);

var _querystring = require('../utils/querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _ajax = require('../utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _autoQueryHelper = require('../utils/auto-query-helper');

var _autoQueryHelper2 = _interopRequireDefault(_autoQueryHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//TODO: when navigating check data-query-target (must be data-ajax="true") or search for closest [data-ajax="true"]
//TODO: support for data-ajax any element (div, span)


// auto query inputs & select key=input name/id, value=$.fn.val()
(0, _jquery2.default)(document).on('change', 'input[data-query], select[data-query]', function () {
	(0, _autoQueryHelper2.default)(this);
});

// auto query a[href='?key=value']
/**
 * Initializes data-query attribute decorated elements.
 * data-query attribute flags the element to be used to update querystring parameter.
 * Navigator module is used to change querystring in such way it does not reload entire page,
 * but only push new state to window history and triggers ajax call based on data-query-target attribute,
 * which should point to element with data-ajax attribute.
 * If data-query-target is not specified, $.fn.closest element with data-ajax attribute is used instead.
 */
(0, _jquery2.default)(document).on('click', '[data-query] a, a[data-query]', function (event) {
	var $a = (0, _jquery2.default)(this);
	var href = $a.attr('href');

	if (/^\?/.test(href) // querystring only or href with the same URL as current location with different query parameters
	|| _querystring2.default.update(href, function () {
		return {};
	}).toLowerCase() === window.location.pathname.toLowerCase()) {
		event.preventDefault();

		var query = _querystring2.default.parse(href);
		_navigator2.default.navigate(query, $a);
	}
});

(0, _jquery2.default)(document).ajaxComplete(function () {
	if (stateToProcess) {
		stateToProcess = false;
		var state = window.history.state.detail;
		if (state && state.uri && state.ajaxElement) {
			processState(state);
		}
	}
});

var stateToProcess = false;

function processState(state) {

	var uri = state.uri;
	var $element = (0, _jquery2.default)(state.ajaxElement);

	if ($element.is('[data-ajax="true"]')) {
		if ($element.data('ajaxInProgress')) {
			$element.data('stateToProcess', true);
			return;
		}

		if ($element.is('form')) $element.attr('action', uri).submit();else if ($element.is('a')) $element.attr('href', uri).click();else {
			(0, _ajax2.default)({
				target: $element.get(0),
				url: uri,
				type: "GET",
				data: []
			});
		}
	}
}

// watch when window state changes
_navigator2.default.onNavigate(function (e) {
	return processState(e);
});


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/auto-query.js
// module id = 1127
// module chunks = 0